import { put } from 'redux-saga/effects';

import { PRE_ZIP_CODE_VALIDATION, ZIP_CODE_VALIDATION } from '../constants/api';
import { callHttp } from '../utils/api';
import { get } from '../utils/httpUtil';

import {
  handleError,
  setZipCodeInfo,
  setZipCodeValidationFlag,
  setZipCodePreValidationLoading,
  setZipCodeValidationLoading,
  getCustomers,
  getDecisions,
  setToken
} from '../actions';

export function* prevalidateZipCode() {
  try {
    yield put(setZipCodePreValidationLoading(true));
    const {
      hasAddress,
      validationInfo: { blocked, allowedAttempts, attemptsLeft }
    } = yield callHttp(get, PRE_ZIP_CODE_VALIDATION);

    yield put(
      setZipCodeInfo({
        attemptsAllowed: allowedAttempts,
        attemptsLeft
      })
    );

    if (!hasAddress || blocked) {
      yield put(setZipCodeValidationFlag(false));
    }
  } catch (err) {
    yield put(setZipCodeValidationFlag(false));
  } finally {
    yield put(setZipCodePreValidationLoading(false));
  }
}

export function* validateZipCode({ payload: zipCode }) {
  try {
    yield put(setZipCodeValidationLoading(true));
    const {
      correctZipCode,
      jwtToken,
      validationInfo: { blocked, allowedAttempts, attemptsLeft }
    } = yield callHttp(get, ZIP_CODE_VALIDATION(zipCode));

    const isSuccessful = correctZipCode && !blocked;
    yield put(
      setZipCodeInfo({
        status: isSuccessful,
        attemptsAllowed: allowedAttempts,
        attemptsLeft
      })
    );

    if (isSuccessful) {
      yield put(setToken(jwtToken));
      yield put(getCustomers());
      yield put(getDecisions());
    } else if (blocked && attemptsLeft) {
      yield put(setZipCodeValidationFlag(false));
    }
  } catch (err) {
    yield put(handleError(err));
  } finally {
    yield put(setZipCodeValidationLoading(false));
  }
}
